// extracted by mini-css-extract-plugin
module.exports = {"legal":"_1IKUIi8U my1 center col-8 mx-auto","link":"_3BqaTTkv"};